import React from "react";
import * as Mui from "@mui/material";
import { SingleValue, MultiValue, BaseProps } from "../types";

interface Props extends BaseProps {
	disabledOptions?: SingleValue[];
}

// Ids for helper text, so the field can point screen readers at it.
let helperTextSeq = 0;

class Component extends React.Component<Props> {

	private readonly helperTextId = `native-select-helper-text-${++helperTextSeq}`;

	public render() {
		const { placeholder, multiple, variant, margin, fullWidth, label, required, disabled, disabledOptions, className, error, helperText } = this.props;
		const { value, options, valueExtractor, labelExtractor, onChange } = this.props;
		return (
			<Mui.FormControl
				className={className}
				variant={variant}
				margin={margin}
				fullWidth={fullWidth}
				required={required}
				disabled={disabled}
			>
				{label &&
					// `required` above is repurposed to suppress the blank/clear <option> — not a
					// real required-field indicator — so override the inherited FormControl context
					// here to avoid a stray "*" on the label.
					<Mui.InputLabel required={false}>{label}</Mui.InputLabel>
				}
				<Mui.Select
					native
					value={value}
					placeholder={placeholder}
					multiple={multiple}
					error={error}
					inputProps={helperText ? { "aria-describedby": this.helperTextId } : undefined}
					onChange={(event) => {
						const { options } = event.target as HTMLSelectElement;
						const values: MultiValue = [];
						for (let i = 0; i < options.length; i++) {
							const option = options[i];
							if (option.selected) {
								const value = this.castValue(option.value);
								(values as SingleValue[]).push(value);
							}
						}
						if (multiple) {
							onChange(values);
						} else {
							onChange(values[0]);
						}
					}}
				>
					{!multiple && !required &&
						<option>
							{placeholder}
						</option>
					}
					{options.map((option) => {
						const value = valueExtractor(option);
						const label = labelExtractor(option);
						const disabled = disabledOptions && disabledOptions.includes(value);
						return (
							<option key={value as string | number} value={value as string | number} disabled={disabled}>
								{label}
							</option>
						);
					})}
				</Mui.Select>
				{helperText && <Mui.FormHelperText id={this.helperTextId} error={error}>{helperText}</Mui.FormHelperText>}
			</Mui.FormControl>
		);
	}

	private castValue(value: string) {
		return this.isNumericValue() ? parseInt(value) : value;
	}

	private isNumericValue() {
		const { options, valueExtractor } = this.props;
		const option = options[0];
		return typeof valueExtractor(option) === "number";
	}
	
}

export const NativeSelect = Component;
